/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmissionRecordMap } from './EmissionRecordMap';
import {
    EmissionRecordMapFromJSON,
    EmissionRecordMapFromJSONTyped,
    EmissionRecordMapToJSON,
    EmissionRecordMapToJSONTyped,
} from './EmissionRecordMap';

/**
 * 
 * @export
 * @interface PaginatedEmissionRecordMapList
 */
export interface PaginatedEmissionRecordMapList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedEmissionRecordMapList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEmissionRecordMapList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<EmissionRecordMap>}
     * @memberof PaginatedEmissionRecordMapList
     */
    results: Array<EmissionRecordMap>;
}

/**
 * Check if a given object implements the PaginatedEmissionRecordMapList interface.
 */
export function instanceOfPaginatedEmissionRecordMapList(value: object): value is PaginatedEmissionRecordMapList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedEmissionRecordMapListFromJSON(json: any): PaginatedEmissionRecordMapList {
    return PaginatedEmissionRecordMapListFromJSONTyped(json, false);
}

export function PaginatedEmissionRecordMapListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedEmissionRecordMapList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(EmissionRecordMapFromJSON)),
    };
}

export function PaginatedEmissionRecordMapListToJSON(json: any): PaginatedEmissionRecordMapList {
    return PaginatedEmissionRecordMapListToJSONTyped(json, false);
}

export function PaginatedEmissionRecordMapListToJSONTyped(value?: PaginatedEmissionRecordMapList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(EmissionRecordMapToJSON)),
    };
}

